<template>
  <header class="header">
    <div class="header__burger-wrap" @click="toggleMenu">
      <button class="header__hamburger" v-bind:class="{opened: openMenu}"><span></span><span></span><span></span></button>
    </div>
    <div class="header__hamburger-content" v-if="openMenu">
      <div class="header__hamburger-menu">
        <div class="header__hamburger-item">
          <a href="https://naprokat.ru/locations" class="header__hamburger-link">Станции аренды</a>
        </div>
        <div class="header__hamburger-item">
          <a href="https://naprokat.ru/terms_and_conditions" class="header__hamburger-link">Условия аренды</a>
        </div>
        <div class="header__hamburger-item">
          <a href="https://naprokat.ru/services" class="header__hamburger-link">Услуги</a>
        </div>
        <div class="header__hamburger-item">
          <a href="https://naprokat.ru/arenda_gruzovyh_auto" class="header__hamburger-link">Аренда грузовых автомобилей</a>
        </div>
        <div class="header__hamburger-item">
          <a href="https://naprokat.ru/about" class="header__hamburger-link">О компании</a>
        </div>
        <div class="header__hamburger-item">
          <a href="https://naprokat.ru/contacts" class="header__hamburger-link">Контакты</a>
        </div>
      </div>
    </div>
    <a class="header__logo" href="/"></a>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      openMenu: false,
    }
  },
  methods: {
    toggleMenu() {
      this.openMenu = !this.openMenu;
    }
  }
}
</script>

<style>
  .header {
    position: relative;
  }
  .header__hamburger-content {
    position: absolute;
    top: 60px;
    left: 45px;
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 20px;
    box-shadow: 0 0 2px 0px rgb(0,0,0,0.23);
    z-index: 1010;
  }
  .header__hamburger-item {
    margin-bottom: 10px;
  }
  .header__hamburger-link {
    color: #000;
    text-decoration: none !important;
    font-weight: bold;
  }
  .header__hamburger-link:hover {
    color: #000;
    opacity: 0.7;
  }
  .header__hamburger {
    position: relative;
  }
  .header__hamburger span {
    -webkit-transition: all 300ms;
    -o-transition: all 300ms;
    transition: all 300ms;
  }
  .header__hamburger.opened span:nth-child(1) {
    position: absolute;
    left: 0;
    top: 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    width: 100%;
  }
  .header__hamburger.opened span:nth-child(2) {
    position: absolute;
    left: 0;
    top: 0;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    width: 100%;
  }
  .header__hamburger.opened span:nth-child(3) {
    width: 0 !important;
  }
 @media screen and (max-width: 760px) {
  .header__hamburger-content {
    left: 15px;
  }
 }
 .header {
  z-index: 999;
 }
 .header__hamburger-content {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 60px;
  padding-left: 45px;
  padding-top: 25px;
 }
 .header__hamburger-link {
  font-size: 18px;
 }
 .footer {
  z-index: 999;
  position: relative;
 }
 .header__hamburger {
  margin: 0 !important;
 }
 .header__hamburger.opened span {
  top: -5px !important;
 }
 .header__burger-wrap {
  padding: 10px;
  cursor: pointer;
  margin: 0 20px;
 }
 .header__hamburger-item {
  margin-bottom: 19px;
 }
 @media screen and (max-width: 760px) {
   .header__burger-wrap {
    margin: 0;
   }
   .header__hamburger-content {
    padding-left: 25px;
   }
   .header__hamburger-item {
    margin-bottom: 15px;
   }
   .header__hamburger-link {
    font-size: 17px;
   }
 }
</style>
